/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseUserData } from './genericApiResponseUserData';
import type { GenericApiResponseUserMessage } from './genericApiResponseUserMessage';
import type { GenericApiResponseUserPagination } from './genericApiResponseUserPagination';
import type { GenericApiResponseUserError } from './genericApiResponseUserError';

export interface GenericApiResponseUser {
  data?: GenericApiResponseUserData;
  message?: GenericApiResponseUserMessage;
  pagination?: GenericApiResponseUserPagination;
  error?: GenericApiResponseUserError;
  statusCode?: number;
}
